export default "__VITE_ASSET__BML8Ecw3__"